module.exports = "/_next/static/images/ebd9bcdf8499692ac79d538df84bd238-Nubank_HickDuarte_58654 (2) 1_md.jpg.webp";